export const Home: React.FC<any> = () => {
  return (
    <section
      className="w-[91%] min-h-[1000px] ml-1  md:ml-4 xl:ml-4 md:min-h-[1000px] mb-10 sm:mb-1 bg-white"
      id="about"
    >
      {/* Content */}
      <div className=" 2xl:ml-5 ml-4 max-w-7xl md:ml-4 pt-4 pb-12 sm:pt-6 sm:pb-16">
        {/* Sub-Heading */}
        <p className="text-lg sm:text-xl font-medium text-[#707070] mb-2">
          I am <span className="font-bold text-[#F1AC20]">Deva P. Seetharam</span>, Inventor, Entrepreneur and
          Technology Advisor
        </p>

        {/* Intro Paragraph */}
        <p className="  mb-8 text-[#454444] tracking-[1px] leading-[30px]  text-justify md:text-start">
          I am an MIT Graduate with a strong systems background. I have experience in a diverse set of areas from energy
          management to pervasive media to embedded networking technologies to distributed systems. I recently
          co-founded DataGlen, a company focused on collecting and curating IoT Data.
        </p>

        {/* Stats + Additional Info (2-column layout on larger screens) */}
        <div className="flex flex-col md:flex-row md:items-start mt-20 md:gap-8">
          <div className="border-2 border-black  rounded-[20px] p-12 w-full md:w-64 mb-8 md:mb-0">
            <div className="flex items-center gap-5 mb-4">
              <p className="text-3xl font-bold text-gray-700">2</p>
              <p className="text-lg  ml-4" style={{ color: "#F1AC20" }}>
                Start ups
              </p>
            </div>
            <hr className="border-gray-200 mb-4" />

            <div className="flex items-center gap-5 mb-4">
              <p className="text-3xl font-bold text-gray-700">21</p>
              <p className="text-lg " style={{ color: "#F1AC20" }}>
                US Patents
              </p>
            </div>
            <hr className="border-gray-200 mb-4" />

            {/* 50 Papers */}
            <div className="flex items-center gap-5">
              <p className="text-3xl font-bold text-gray-700">50</p>
              <p className="text-lg " style={{ color: "#F1AC20" }}>
                Papers
              </p>
            </div>
          </div>

          <div className="flex-1 text-[#454444]  text-justify md:text-start">
            <p className=" text-[#454444]  mb-6 ">
              I recently co-founded DataGlen, a company focused on collecting and curating IoT Data. I serve as one of
              the General Chairs for ACM e-Energy 2015, a conference that aims to be a premier venue for research in
              computing and communication for smart energy systems.
            </p>
            <p className=" text-[#454444] mb-6">
              I founded Smarter Energy Research for IBM India in 2008. Our work has been well recognized with awards
              like 2014 MIT TR35, 2013 Indian National Academy Young Engineer, and others.
            </p>
            <p className="text-[#454444]  mb-6">
              Whatever (the little) I have accomplished is only because I have been fortunate to have a great family,
              teachers, mentors, and colleagues.
            </p>
            <p className="text-[#454444] tracking-[1px] leading-[35px]">Thank you for stopping by!!!</p>
          </div>
        </div>
      </div>
    </section>
  );
};
